import React, { useEffect, useState } from "react";
import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  Nav,
  Row,
  Tab,
  Spinner,
} from "react-bootstrap";
import CustomDropdownToggle from "Common/CustomDropdownToggle";

//Images
import productimg1 from "../../../../assets/images/products/32/img-1.png";
import productimg6 from "../../../../assets/images/products/32/img-6.png";
import productimg7 from "../../../../assets/images/products/32/img-7.png";

import DiscountCard from "./DiscountCard";
import CourseIncludes from "./CourseIncludes";
import InstructorDetails from "./InstructorDetails";
import Membership from "./Membership";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getLeadById } from "../../../slices/thunk";
import NoVideo from "../../../assets/images/no-video.jpg";

//SimpleBar
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";

const Overview = () => {
  const dispatch: any = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const [loading, setLoading] = useState(false);
  const [leadData, setLeadData] = useState<any>({});
  const [isOpen, setIsOpen] = useState(false);
  //const leadData = useSelector((state: any) => state.Leads.singleLead);
  const { t } = useTranslation(); //

  useEffect(() => {
    setLoading(true);
    dispatch(getLeadById(id)).then((resp: any) => {
      setLeadData(resp);
    });
    setLoading(false);
  }, []);

  const adjustImageSize = (
    imgElement: HTMLImageElement,
    maxWidth: number,
    maxHeight: number
  ) => {
    const img = new Image();
    img.src = imgElement.src;

    img.onload = function () {
      let { width, height } = img;
      const aspectRatio = width / height;

      if (width > maxWidth) {
        width = maxWidth;
        height = width / aspectRatio;
      }

      if (height > maxHeight) {
        height = maxHeight;
        width = height * aspectRatio;
      }

      imgElement.style.width = `${width}px`;
      imgElement.style.height = `${height}px`;
      imgElement.style.objectFit = "contain";
    };
  };

  const renderMedia = (url: any) => {
    // Get the file extension
    const fileExtension = url.split(".").pop().toLowerCase();

    // Define supported video extensions
    const videoExtensions = ["mp4", "mov", "avi", "mkv"];

    // Check if the file is a video
    if (videoExtensions.includes(fileExtension)) {
      return (
        <video controls src={url}>
          Your browser does not support the video tag.
        </video>
      );
    }

    // Check if the file is an image

    const validExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];

    if (!validExtensions.includes(fileExtension)) return null;

    return (
      <>
        {/* Small Image */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setIsOpen(true)}
        >
          <img
            src={url}
            onLoad={(e) => adjustImageSize(e.currentTarget, 300, 200)}
            style={{
              transition: "0.3s ease-in-out",
              borderRadius: "5px",
            }}
            alt="media"
          />
        </div>

        {/* Popup (Modal) */}
        {isOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={() => setIsOpen(false)}
          >
            <img
              src={url}
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "10px",
                transition: "0.3s ease-in-out",
                cursor: "pointer",
              }}
              alt="media"
            />
          </div>
        )}
      </>
    );
    return <p>Unsupported media type</p>;
  };

  document.title = t("Project Overview");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            {loading ? ( // Show spinner while loading
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <Row>
                <Col xl={9} lg={8}>
                  <Tab.Container defaultActiveKey="description">
                    <Card>
                      <Card.Body>
                        <div className="position-relative rounded overflow-hidden mb-4">
                          <h4>{leadData && leadData.lead_cat_id}</h4>
                          <h6>{leadData && leadData.lead_sub_cat}</h6>
                          <div className="ratio ratio-21x9 new-overview-lead">
                            {leadData && leadData.lead_video_url ? (
                              renderMedia(leadData.lead_video_url)
                            ) : (
                              <div className="d-flex align-items-center justify-content-center">
                                <img
                                  src={NoVideo}
                                  style={{ width: "45%", marginTop: "20px" }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="position-absolute d-flex gap-2 top-0 end-0 m-3 d-none">
                            <Dropdown>
                              <Dropdown.Toggle
                                isButton={true}
                                as={CustomDropdownToggle}
                                className="btn bg-white btn-icon"
                              >
                                <i className="bi bi-share"></i>
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu-end arrow-none">
                                <Dropdown.Item href="#">
                                  <i className="bi bi-facebook me-1 align-baseline"></i>{" "}
                                  Facebook
                                </Dropdown.Item>
                                <Dropdown.Item href="#">
                                  <i className="bi bi-instagram me-1 align-baseline"></i>{" "}
                                  Instagram
                                </Dropdown.Item>
                                <Dropdown.Item href="#">
                                  <i className="bi bi-whatsapp me-1 align-baseline"></i>{" "}
                                  Whatsapp
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                        <Button
                          variant="subtle-warning"
                          className="custom-toggle btn-icon btn-sm active float-end"
                          data-bs-toggle="button"
                          aria-pressed="true"
                        >
                          <span className="icon-on">
                            <i className="bi bi-star"></i>
                          </span>
                          <span className="icon-off">
                            <i className="bi bi-star-fill"></i>
                          </span>
                        </Button>

                        <ul className="list-unstyled hstack gap-2 flex-wrap mb-0">
                          <li>
                            <Link to="#!" className="text-reset">
                              <i className="bi bi-box-seam align-baseline me-1"></i>{" "}
                              {leadData && leadData.lead_sub_cat}
                            </Link>
                          </li>
                          <li className="text-warning">
                            <i className="bi bi-star-fill align-baseline"></i>
                            <i className="bi bi-star-fill align-baseline"></i>
                            <i className="bi bi-star-fill align-baseline"></i>
                            <i className="bi bi-star-fill align-baseline"></i>
                            <i className="bi bi-star-half align-baseline"></i>
                            <span className="text-body ms-1">4.5</span>
                          </li>
                          <li>
                            <span className="badge bg-success-subtle text-success">
                              {leadData && leadData.lead_job_status}
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                      <Card.Body>
                        <Nav
                          as="ul"
                          variant="tabs"
                          className="nav-tabs-custom rounded card-header-tabs border-bottom-0 mx-0"
                        >
                          <Nav.Item as="li">
                            <Nav.Link eventKey="description">
                              Description
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li">
                            <Nav.Link eventKey="video">
                              Contact Information
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li">
                            <Nav.Link eventKey="reviews">Reviews</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="faqs">FAQs</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </Card.Body>
                    </Card>
                    <Card>
                      <Card.Body>
                        <Tab.Content>
                          <Tab.Pane eventKey="description" id="description">
                            <>
                              <h6 className="card-title mb-3">Description</h6>
                              <p className="text-muted mb-2">
                                {leadData && leadData.lead_description}
                              </p>
                            </>
                          </Tab.Pane>
                          <Tab.Pane eventKey="video" id="videoTutorials">
                            <>
                              <h6 className="card-title mb-3">Address</h6>
                              <p className="text-muted mb-2">
                                {leadData && leadData.lead_address},{" "}
                                {leadData && leadData.lead_city},{" "}
                                {leadData && leadData.lead_state},{" "}
                                {leadData && leadData.lead_zip_code}
                              </p>
                            </>
                          </Tab.Pane>
                          <Tab.Pane eventKey="reviews" id="reviews">
                        
                          </Tab.Pane>
                          <Tab.Pane eventKey="faqs" id="faqs">

                          </Tab.Pane>
                        </Tab.Content>
                      </Card.Body>
                    </Card>
                  </Tab.Container>
                </Col>
                <Col xl={3} lg={4}>
                  <InstructorDetails data={leadData} />
                  {/* <DiscountCard data={leadData} /> */}
                  {/* <CourseIncludes /> */}
                </Col>
              </Row>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Overview;
